import { Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useSwiper } from "swiper/react";
import coins from "./assets/icons/coins.svg";
import coins_light from "./assets/icons/coins_light.svg";
import CustomPaper from "../../../../_components/CustomPaper";
import Text from "../../../../_components/Text";
import { roundToDecimals } from "../../../../_utils/roundToDecimals";
interface Props {
  value: number | undefined;
  label: string;
  onClick?: () => void;
}

export const ProfitRealizedInfo = ({ value, label }: Props) => {
  const theme = useTheme();
  const swiper = useSwiper();

  const handleSlideNext = () => {
    swiper.slideNext();
  };

  return (
    <Stack direction={"row"} spacing={1} sx={{ flex: 1, width: "100%" }} onClick={handleSlideNext}>
      <CustomPaper
        fullWidth
        sx={{
          position: "relative",
          backgroundImage: `url(${theme.palette.mode === "dark" ? coins : coins_light})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "right",
          backgroundPositionX: "113%",
          backgroundSize: "43%",
          backgroundPositionY: "center",
          height: "119px",
        }}
      >
        <Stack direction="row" justifyContent="space-between" height="100%">
          <Stack direction="column" justifyContent="space-between"  height="100%">
            <Text variant="h1">
              {value !== undefined ? `$${roundToDecimals(value, 2)}` : "N/A"}
            </Text>
            <Text maxWidth="200px" variant="regular" color={theme.myTheme.colors.foreground50}>
              {value !== undefined ? label : "Launch your first bot to see realized profit"}
            </Text>
          </Stack>
        </Stack>
      </CustomPaper>
    </Stack>
  );
};
